module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "carousel",
      "name": "Carousel"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('carousel', [_c('slider', [_c('img', {
    attrs: {
      "src": "https://placehold.it/1200x500?text=one"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_c('h3', [_vm._v("Slide #1")]), _vm._v(" "), _c('p', [_vm._v("sunt in culpa qui officia deserunt mollit a.")])])]), _vm._v(" "), _c('slider', [_c('img', {
    attrs: {
      "src": "https://placehold.it/1200x500?text=two"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_c('h3', [_vm._v("Slide #2")]), _vm._v(" "), _c('p', [_vm._v("sunt in culpa qui officia deserunt mollit a.")])])]), _vm._v(" "), _c('slider', [_c('img', {
    attrs: {
      "src": "https://placehold.it/1200x500?text=three"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_c('h3', [_vm._v("Slide #3")]), _vm._v(" "), _c('p', [_vm._v("sunt in culpa qui officia deserunt mollit a.")])])])], 1)], 1), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <carousel>\n      <slider>\n        <img src=\"https://placehold.it/1200x400?text=one\">\n        <div class=\"carousel-caption\">\n          ...\n        </div>\n      </slider>\n      <slider>\n        <img src=\"https://placehold.it/1200x400?text=two\">\n      </slider>\n      <slider>\n        <img src=\"https://placehold.it/1200x400?text=three\">\n      </slider>\n    </carousel>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("indicators")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("true")])]), _vm._v(" "), _c('p', [_vm._v("Whether to show the indicators.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("controls")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("true")])]), _vm._v(" "), _c('p', [_vm._v("Whether to show the direction controls.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("interval")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("5000")])]), _vm._v(" "), _c('p', [_vm._v("The amount of time to delay between automatically cycling an item. If set to 0 or a negative number,\n        carousel will not automatically cycle.\n      ")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16e8ad30", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16e8ad30!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/carouselDocs.vue
// module id = 160
// module chunks = 0